import React, { useState, useEffect } from 'react'
import Flatpickr from 'react-flatpickr'
import Select from 'react-select'
import { ColorChecker } from '../../Functions/ColorChecker'

export default function PagesFilter({team, beneficiariesTitle, page, filterFields, currentOrder = "Descending", url, filterActive, inverted = false, openOnLoad}) {
    const [showFilters, setShowFilters] = useState(false)
    const [filters, setFilters] = useState(filterFields)
    const [buttonTextColor, setButtonTextColor] = useState('white')
    const [buttonColor, setButtonColor] = useState(page.button_color)

    useEffect(() => {
        let result = ColorChecker(buttonColor)
        if (result == true) setButtonTextColor('black')
        if (openOnLoad) setShowFilters(true)
    }, [])

    let orderOptions = [
        {id: 1, name: 'Ascending'},
        {id: 2, name: 'Descending'}
    ]
    const [selectedOrder, setSelectedOrder] = useState(currentOrder == "Ascending" ? orderOptions[0] : orderOptions[1])

    const handleInputChange = (field, newValue) => {
        let fields = filters.map(filter => {
            if (filter.id == field.id) {
                return {
                    ...filter,
                    value: newValue
                }
            }

            return filter
        })

        setFilters(fields)
    }

    const clearFilters = () => {
        window.location = `${url}?preview=1&request_action=clear`
    }

    const handleSubmit = () => {
        const encodedFilters = encodeURIComponent(JSON.stringify(filters))

        window.location = `${url}?preview=1&request_action=filter&filters=${encodedFilters}&order=${selectedOrder.name}`
    }


    return (
        <div className='filter-margin cu-page-filter-color' style={{color: page.template == 'sponsorship_video_2' ? page.text_color : 'inherit'}}>
            {!inverted &&
                <>
                <div>
                    <button className='btn btn-primary' onClick={() => {setShowFilters(!showFilters); document.activeElement.blur()}} style = {{backgroundColor: page.button_color, borderColor: page.button_color, color: buttonTextColor}}>
                        {showFilters && <>Hide Filters</>}
                        {!showFilters && <>Show Filters</>}
                    </button>

                    {filterActive && <span className='ml-2'><b>Filter is currently active</b></span>}
                </div>

                {showFilters && (
                    <div className='card mt-3'>
                        <div className='card-body'>
                            <div className='row row-project'>
                                {filters.map(field => (
                                    <div className='col-sm-6 col-md-4 col-lg-3' key={field.id}>
                                        <div className='form-group'>
                                            <label htmlFor={field.name}>{ field.name }</label>
                                            {(field.value_type == 'text' || field.value_type == 'link') && (
                                                <input
                                                    type='text'
                                                    placeholder={field.name}
                                                    className='form-control'
                                                    name={field.name}
                                                    value={field.value}
                                                    onChange={(e) => {
                                                        handleInputChange(field, e.target.value)
                                                    }}
                                                />
                                            )}

                                            {field.value_type == 'long_text' && (
                                                <textarea
                                                    name={field.name}
                                                    className='form-control'
                                                    placeholder={field.name}
                                                    value={field.value}
                                                    onChange={(e) => {
                                                        handleInputChange(field, e.target.value)
                                                    }}
                                                />
                                            )}

                                            {field.value_type == 'date' && (
                                                <Flatpickr className="form-control"
                                                    value={field.value}
                                                    onChange={(date, dateStr) => {
                                                        handleInputChange(field, dateStr)
                                                    }}
                                                />
                                            )}

                                            {field.value_type == 'select' &&
                                                <div className="input-group">
                                                    <Select
                                                    className="w-100 select-audience"
                                                    classNamePrefix="select-audience"
                                                    isMulti
                                                    value={field.value}
                                                    onChange={(value) => handleInputChange(field, value)}
                                                    options={field.select_options}
                                                    getOptionLabel={option => `${option}`}
                                                    getOptionValue={option => option }
                                                    />
                                                </div>
                                            }

                                            {field.value_type == 'dynamic' && 
                                                <>
                                                    <input
                                                        type='text'
                                                        placeholder={field.name}
                                                        className='form-control'
                                                        name={field.name}
                                                        value={field.value}
                                                        onChange={(e) => {
                                                            handleInputChange(field, e.target.value)
                                                        }}
                                                    />
                                                    <small>Enter value in this format "Text (YYYY-MM-DD)", you can also just enter the date or text only</small>
                                                </>
                                            }
                                        </div>
                                    </div>
                                ))}

                                <div className='col-sm-6 col-md-4 col-lg-3'>
                                    <div class="form-group">
                                        <label htmlFor="order">Select Order</label>
                                        <div className="input-group" id="order">
                                        <Select
                                            className="form-control select-beneficiaries"
                                            classNamePrefix="select-beneficiaries"
                                            onChange={(order) => setSelectedOrder(order)}
                                            options={orderOptions}
                                            getOptionLabel={(option) =>
                                                `${option.name}`
                                            }
                                            getOptionValue={(order) => order.id}
                                            value={selectedOrder}
                                        />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='d-flex mt-3' style={{justifyContent: 'flex-end'}}>
                                <button className='btn btn-primary mr-3' onClick={handleSubmit} style = {{backgroundColor: page.button_color, borderColor: page.button_color, color: buttonTextColor}}>
                                    Filter { beneficiariesTitle }
                                </button>
                                <button className='btn btn-danger' onClick={clearFilters}>Clear Filters</button>
                            </div>
                        </div>
                    </div>
                )}
            </>
            }

            {inverted &&
                <>
                <div style={{height: '80px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}} className=' pf-button-hover-remove'>
                    {filterActive && <span className='mr-2'><b>Filter is currently active</b></span>}
                    <button className='btn btn-primary' onClick={() => {setShowFilters(!showFilters); document.activeElement.blur()}} style={{
                        backgroundColor: page.button_color, 
                        borderColor: page.button_color, 
                        color: buttonTextColor,
                        marginRight: '20px'
                    }}>
                        {showFilters && <>Hide Filters</>}
                        {!showFilters && <>Show Filters</>}
                    </button>
                </div>

                {showFilters && (
                    <div className='card mt-3'>
                        <div className='card-body'>
                            <div className='row row-project'>
                                {filters.map(field => (
                                    <div className='col-sm-6 col-md-4 col-lg-3' key={field.id}>
                                        <div className='form-group'>
                                            <label htmlFor={field.name}>{ field.name }</label>
                                            {(field.value_type == 'text' || field.value_type == 'link') && (
                                                <input
                                                    type='text'
                                                    placeholder={field.name}
                                                    className='form-control'
                                                    name={field.name}
                                                    value={field.value}
                                                    onChange={(e) => {
                                                        handleInputChange(field, e.target.value)
                                                    }}
                                                />
                                            )}

                                            {field.value_type == 'long_text' && (
                                                <textarea
                                                    name={field.name}
                                                    className='form-control'
                                                    placeholder={field.name}
                                                    value={field.value}
                                                    onChange={(e) => {
                                                        handleInputChange(field, e.target.value)
                                                    }}
                                                />
                                            )}

                                            {field.value_type == 'date' && (
                                                <Flatpickr className="form-control"
                                                    value={field.value}
                                                    onChange={(date, dateStr) => {
                                                        handleInputChange(field, dateStr)
                                                    }}
                                                />
                                            )}

                                            {field.value_type == 'select' &&
                                                <div className="input-group">
                                                    <Select
                                                    className="w-100 select-audience"
                                                    classNamePrefix="select-audience"
                                                    isMulti
                                                    value={field.value}
                                                    onChange={(value) => handleInputChange(field, value)}
                                                    options={field.select_options}
                                                    getOptionLabel={option => `${option}`}
                                                    getOptionValue={option => option }
                                                    />
                                                </div>
                                            }

                                            {field.value_type == 'dynamic' && 
                                                <>
                                                    <input
                                                        type='text'
                                                        placeholder={field.name}
                                                        className='form-control'
                                                        name={field.name}
                                                        value={field.value}
                                                        onChange={(e) => {
                                                            handleInputChange(field, e.target.value)
                                                        }}
                                                    />
                                                    <small>Enter value in this format "Text (YYYY-MM-DD)", you can also just enter the date or text only</small>
                                                </>
                                            }
                                        </div>
                                    </div>
                                ))}

                                <div className='col-sm-6 col-md-4 col-lg-3'>
                                    <div class="form-group">
                                        <label htmlFor="order">Select Order</label>
                                        <div className="input-group" id="order">
                                        <Select
                                            className="form-control select-beneficiaries"
                                            classNamePrefix="select-beneficiaries"
                                            onChange={(order) => setSelectedOrder(order)}
                                            options={orderOptions}
                                            getOptionLabel={(option) =>
                                                `${option.name}`
                                            }
                                            getOptionValue={(order) => order.id}
                                            value={selectedOrder}
                                        />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='d-flex mt-3' style={{justifyContent: 'flex-end'}}>
                                <button className='btn btn-primary mr-3' onClick={handleSubmit} style = {{backgroundColor: page.button_color, borderColor: page.button_color, color: buttonTextColor}}>
                                    Filter { beneficiariesTitle }
                                </button>
                                <button className='btn btn-danger' onClick={clearFilters}>Clear Filters</button>
                            </div>
                        </div>
                    </div>
                )}
            </>
            }
        </div>
    )
}